import { render, staticRenderFns } from "./TRT_Dashboard.vue?vue&type=template&id=679d5a11&scoped=true&"
import script from "./TRT_Dashboard.vue?vue&type=script&lang=js&"
export * from "./TRT_Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./TRT_Dashboard.vue?vue&type=style&index=0&id=679d5a11&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679d5a11",
  null
  
)

export default component.exports